var map = {
	"./nogame-1.png": 7399,
	"./nogame-2.png": 7810,
	"./nogame-3.png": 5178,
	"./nogame-4.png": 2836,
	"./nogame-5.png": 9498,
	"./nogame-6.png": 9317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8184;